import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { StyledCellWrapper } from '@urc-ui/components/styles';
import { DateText } from '@urc-ui/components/date-text';

export function DateTextCellRenderer(props: ICellRendererParams) {
  return (
    <StyledCellWrapper>
      <DateText timestamp={props.value} />
    </StyledCellWrapper>
  );
}
